import { render } from "./linkDiseaseSyndrome.vue?vue&type=template&id=7f75459c&scoped=true"
import script from "./linkDiseaseSyndrome.vue?vue&type=script&lang=js"
export * from "./linkDiseaseSyndrome.vue?vue&type=script&lang=js"

import "./linkDiseaseSyndrome.vue?vue&type=style&index=0&id=7f75459c&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f75459c"]])

export default __exports__